module.exports = __webpack_public_path__ + "static/scale-model-of-greenwich-steps-in-berkeley-california-9ecc579567832f79bcdc10a3da5f5b1b.png";